<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 09:43:46
 * @LastEditTime: 2021-01-22 13:28:18
 * @LastEditors: daikeyi
 -->
<template>
<div id="page_Container" class="gooddetail" :class="{'no-product': noProduct}">
    <div class="page" :class="{'video-show-page':videoShow}" v-if="!noProduct">
        <div id="main-container" class="main-container" v-if="ajaxShow">
            <!--商品图片-->
            <div class="lunbo good-swiper" v-if="productImages">
                <van-swipe @change="onChange" ref="proSwiper">
                    <!-- <van-swipe-item v-if="hasSwiperVideo">
                        <div :style="videoBg">
                            <div class="playBtn" @click="clickPlay"><van-icon name="play" size="30px" color="#fff"/></div>
                        </div>
                    </van-swipe-item> -->
                    <van-swipe-item v-if="hasSwiperVideo">
                        <video id="swiperBigVideo" controls preload x5-video-player-type="h5-page" :poster="productImages[0]" playsinline>
                            <source :src="swiperBigVideoSource" type="video/mp4">
                        </video>
                    </van-swipe-item>
                    <van-swipe-item class="good-center" v-for="(image, index) in productImages" :key="index">
                        <img :src="image" class="good-img">
                    </van-swipe-item>
                    <div class="custom-indicator" slot="indicator">
                        <div v-show="hasSwiperVideo" :class="{'swiper-active': clickTagName==='player'}" class="mr10" @click="changeSwiper('player')">
                            <van-icon name="play" />视频</div>
                        <div v-show="hasSwiperVideo" :class="{'swiper-active': clickTagName==='photo'}" @click="changeSwiper('photo')">图片</div>
                        <div class="indicator" v-show="clickTagName==='photo'||!hasSwiperVideo"> {{ hasSwiperVideo?current:( current+1) }}/{{productImages.length}} </div>
                    </div>
                </van-swipe>
                <div class='cartPicFixed' @click.prevent="gocartpage()">
                    <img src="../assets/img/goods/cartPic.png" alt="">
                </div>
            </div>
            <!-- 商品详情 -->
            <div class="goods-detail">
                <div class="goodsprice" v-if="goodsdetildata.minPrice === goodsdetildata.maxPrice">
                    <div class='priceBox'>
                        <p class="price-title">¥{{ESVBase.numberTofixed(goodsdetildata.minPrice)}}
                            <!-- <span class="openType">{{goodsdetildata.businessTypeDesc}}</span> -->
                        </p>
                        <integralDeduction class='inteDetails' v-if='goodsdetildata.maxDeductionAmount' :goodData='goodsdetildata'></integralDeduction>
                    </div>
                    <div class="marketprice" v-if="goodsdetildata.minPriceMarket">
                        <span class="text">价格:</span>
                        <span class="price">¥{{ESVBase.numberTofixed(goodsdetildata.minPriceMarket)}}</span>
                    </div>
                </div>

                <div class="goodsprice" v-if="goodsdetildata.minPrice !== goodsdetildata.maxPrice">
                    <div class='priceBox'>
                        <p class="price-title">¥{{ESVBase.numberTofixed(goodsdetildata.minPrice)}}-{{ESVBase.numberTofixed(goodsdetildata.maxPrice)}}
                            <!-- <span class="openType">{{goodsdetildata.businessTypeDesc}}</span> -->
                        </p>
                        <integralDeduction class='inteDetails' v-if='goodsdetildata.maxDeductionAmount' :goodData='goodsdetildata'></integralDeduction>
                    </div>
                    <div class="marketprice" v-if="goodsdetildata.minPriceMarket">
                        <span class="text">价格：</span>
                        <span class="price">¥{{ESVBase.numberTofixed(goodsdetildata.minPriceMarket)}}-{{ESVBase.numberTofixed(goodsdetildata.maxPriceMarket)}}</span>
                    </div>
                </div>
                <p class="goodstitle">{{goodsdetildata.name}}</p>
                <p class="goodstitle2" v-if="goodsdetildata.caption">{{goodsdetildata.caption}}</p>
                <p class="buydata">
                    <span class="payNum">{{goodsdetildata.salesNum ? goodsdetildata.salesNum : 0}}人付款</span>
                    <!-- <span>{{goodsdetildata.contentNum ? goodsdetildata.contentNum : 0}}条评价</span> -->
                    <span>{{goodsdetildata.goodPoint ? goodsdetildata.goodPoint : 0}}%好评</span>
                </p>
            </div>
            <div>
                <van-cell-group>
                    <van-cell title="" value="" class='cellStyle' v-show="retailStoreProductFlag">
                        <template slot="title">
                            <span class="custom-title">最高赚¥{{goodsdetildata.maxStoreProfit?goodsdetildata.maxStoreProfit.toFixed(2): ''}}元</span>
                        </template>
                        <template slot="default">
                            <div class='buttonBox' @click='fxDetailsUrlClick'>
                                分享去赚钱
                            </div>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
            <div class="couponshell" @click="Coupon()" v-if="showAllCoupon">
                <div class="couponcontain" style="display:flex">
                    <div class="couponcontain-left">优惠</div>
                    <div class="couponcontain-right">
                        <div v-if="activityList && activityList.length != 0" class="flex couponp">
                            <div>
                                <van-tag color="rgba(255,190,43,0.2)" round text-color="#FFBE2B">优惠活动</van-tag>
                                <span class="actFirst" v-for="(list, idx) in activityListFirst" v-show='idx <= 1' :key="idx">{{list}}</span>
                            </div>
                            <!-- <div style="flex:none">
                                <span class="s-r">领券</span>
                            </div> -->
                        </div>
                        <div v-if="minPoint">
                            <van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">积分</van-tag>
                            <span class="integral-item">购买可得{{minPoint}}积分起</span>
                        </div>
                        <!-- 套装 -->
                        <div v-show="goodsdetildata.groupProductQuantity && goodsdetildata.groupProductQuantity!== 0">
                            <van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">套装</van-tag>
                            <span class="integral-item">该商品共有{{goodsdetildata.groupProductQuantity}}个优惠套装</span>
                        </div>
                        <!-- 优惠券 -->
                        <div v-show="goodsdetildata.genericCouponList && goodsdetildata.genericCouponList.length!== 0">
                            <van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">优惠</van-tag>
                            <span class="integral-item">该商品共有{{goodsdetildata.genericCouponList?goodsdetildata.genericCouponList.length: 0}}张优惠券</span>
                        </div>
                    </div>
                    <div class="couponcontain-right-arrows right-arrows">查看</div>
                    <!-- <p class="couponp" v-if="couponList.length != 0">优惠
                        <span class="mark coupon-title">优惠劵</span>
                        <span class="firstcoupon" v-for="(couponName, idx) in couponNameList" :key="idx">{{couponName}}</span>
                        <span class="f-right">领券</span>
                    </p> -->

                </div>
            </div>
            <!-- 商品规格 -->
            <div class="specifications" @click="specifications()" v-if="sku">
                <P>
                    <span style="float: left;">规格</span>
                    <span class="notchoosed" v-if="selectedStyles.length !== specificationNum">选择</span>
                    <span class="choosed" v-if="selectedStyles.length === specificationNum">{{selectedStylesString}}</span>
                </P>
            </div>
            <div class="specifications sku-wrapper">
                <van-sku class="sku-container descBox" ref="vanSku" v-model="showBase" :sku="sku" :initial-sku="initialSku" :goods="goods" :goods-id="goodsId" :hide-stock="false" :quota="quota" :quota-used="quotaUsed" :reset-stepper-on-hide="resetStepperOnHide" :reset-selected-sku-on-hide="resetSelectedSkuOnHide" :close-on-click-overlay="closeOnClickOverlay" :disable-stepper-input="disableStepperInput" @add-cart="onAddCartClicked" @buy-clicked="onBuyClicked" @sku-selected="onSkuSelected" :custom-stepper-config="customStepperConfig">
                    <template slot="van-sku-stepper-stock" slot-scope="props">
                        <div class="van-sku-stepper-container">
                            <span class="van-sku__price-symbol">￥</span>
                            <span class="van-sku__price-num">{{ props.price }}</span>
                        </div>
                    </template>
                    <template slot="sku-actions" slot-scope="props">
                        <div class="van-sku-actions">
                            <van-button class="determine-btn" v-if="isgocart === 1 || isgocart === 2" type="primary" bottom-action @click="props.skuEventBus.$emit('sku:buy')">确定</van-button>
                            <van-button v-if="isgocart === 0" type="primary" bottom-action class="left-btn" @click="props.skuEventBus.$emit('sku:addCart')" :disabled="Number(goodsdetildata.type) === 4">加入购物车</van-button>
                            <van-button v-if="isgocart === 0" type="primary" bottom-action class="right-btn" @click="props.skuEventBus.$emit('sku:buy')" :disabled="Number(goodsdetildata.type) === 4">立即购买</van-button>
                        </div>
                    </template>

                    <!-- 自定义 sku-header-price -->
                    <!-- <template slot="sku-group" slot-scope="props">
                        <div class="van-sku__goods-price">

                        </div>
                    </template> -->
                </van-sku>
            </div>
            <!-- 商品参数 -->
            <div class="parameter" @click="parame()" v-if="productParameterList.length != 0">
                <p>参数
                    <span class="notchoosed">{{productParameterList[0].key}}...</span>
                </p>
            </div>
            <!-- 商品评价 -->
            <div :class="['evaluation', {'evaluation2': introduction.length === 0}]" v-if="productComment.accountAvatar">
                <div class="evatitle">
                    <span>商品评价（{{goodsdetildata.contentNum}}）</span>
                    <div class="evatitle-right">
                        <span @click="goevaluation(productId)">查看全部</span>
                    </div>
                </div>
                <evaluationCommon :productComment="productComment" :goodsdetildata="goodsdetildata" :productId="productId" :evabuttonFlag="true" :imgShow="false" :changeFlag='false' :showRate="true" :isLimit="true"></evaluationCommon>
            </div>

            <!-- 详情图 -->
            <div class="detailimg" v-if="(introduction && introduction.length !== 0)">
                <div class="detailimgtitle"><span>详情</span></div>
                <div class="detailimgContent">
                    <!-- <div class="prism-player" id="detailVideo"></div> -->
                    <!-- <Aliplayer :initObj="detailVideo" @playerinit="detailVideoInit" v-if="hasDetailVideo"></Aliplayer> -->
                    <video id="detailVideo" controls preload x5-video-player-type="h5-page" v-show="detailVideoSource" playsinline>
                        <source :src="detailVideoSource" type="video/mp4">
                    </video>
                    <img v-for="img in introduction" :key="img.index" v-lazy="img" @click="showBigDetaileImg(img)">
                </div>
                <listBottom v-if='finishedOk'></listBottom>
            </div>
        </div>
        <!-- 底部导航 -->
        <div v-if="ajaxShow">
            <div class="downtab" v-if="showCoupon === false && showBase === false && showParameter === false">
                <div class="homebtn btn" @click="gohome">
                    <img src="../assets/img/home/downtab/home@3x.png" alt="">
                    <p>首页</p>
                </div>
                <div class="collectbtn btn" @click.prevent="collection">
                    <img :src="active === 1 ? icon.active : icon.normal" alt="">
                    <p>收藏</p>
                </div>
                <div class="collectbtn btn" @click="goService">
                    <a :href='contactCustomer + "&commodityid=" + goodsdetildata.productId'>
                        <img :src="icon.kf" alt="">
                        <p>客服</p>
                    </a>
                </div>

                <van-button type="primary" bottom-action class="gobuybtn eventbtn btn" @click="gobuy" :disabled="Number(goodsdetildata.type) === 4">立即购买</van-button>
                <van-button type="primary" bottom-action class="gocartbtn eventbtn btn" @click="gocart" :disabled="Number(goodsdetildata.type) === 4">加入购物车</van-button>
                <!-- <div class="gobuybtn eventbtn btn" @click="gobuy" :disabled="Number(goodsdetildata.type) === 4">立即购买</div>
                <div class="gocartbtn eventbtn btn" @click="gocart" :disabled="Number(goodsdetildata.type) === 4">加入购物车</div> -->
            </div>
        </div>
        <div class='couponshell' v-show="showCoupon">
            <div class="couponcontain">
                <van-popup v-model="showCoupon" position="bottom" :close-on-click-overlay="closeOnClickOverlay">
                    <div class="paratitle">优惠</div>
                    <div class="promotion-wrapper">
                        <div class="sale-promotion-wrapper">
                            <div class="title">促销</div>
                            <!-- 活动 -->
                            <div class="activicontent">
                                <div class="sale-promotion right-arrows" @click="goActivity(activityListnew[0])" v-if="activityList && activityList.length >= 1">
                                    <div class="mr-6">
                                        <van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">活动</van-tag>
                                    </div>

                                    <div class="activiall">
                                        <template  v-for="(name, idx) in activityListnew[0].actname">
                                            {{idx < 1? `${name}，` : idx === 1 ? name: ''}}
                                        </template>

                                        <p>{{activityListnew[0].timerange}}</p>
                                    </div>

                                </div>
                                <div class="couponcontentshell" v-if="couponList && couponList.length !== 0">

                                    <div :class="{'coupon-diabled': item.receiveCouponNum === 0, coupon:true, clearfix:true}" v-for="item in couponList" :key='item.index'>
                                        <div class="couponcontent">
                                            <p class="num">￥
                                                <span>{{item.faceAmount}}</span>
                                                <span class='numFonts'>优惠券</span>
                                            </p>
                                            <p class="limit">满{{item.thresholdAmount}}元可使用</p>
                                            <span class="period" v-if="item.couponValidityType === '2' && item.couponValidityStart && item.couponValidityEnd">有效期:{{item.couponValidityStart.substring(0,10)}}~{{item.couponValidityEnd.substring(0,10)}}</span>
                                            <span class="period" v-if="item.couponValidityType === '1'">领取后{{item.couponValidityDay}}天内有效</span>
                                        </div>
                                        <div class="couponbtn" @click="receiveCoupon(item)">
                                            <span>立即领取</span>
                                        </div>
                                        <!-- <div class="couponbtn" v-if="item.receiveCouponNum === 0">
                                            <span>已经领取</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 套装 -->
                            <div class="sale-promotion couponp right-arrows" @click="esvOpenPage({name:'OPGroupList', params: {productId: goodsdetildata.productId, spreadingCode}})" v-show="goodsdetildata.groupProductQuantity && goodsdetildata.groupProductQuantity!== 0">
                                <div class="mr-6"><van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">套装</van-tag></div>
                                <div class="content">该商品共有{{goodsdetildata.groupProductQuantity}}个优惠套装</div>
                            </div>
                            <!-- 积分 -->
                            <div class="sale-promotion" v-if="minPoint">
                                <div class="mr-6"><van-tag color="rgba(238,46,80,0.2)" round text-color="#EE2E50">积分</van-tag></div>
                                <div class="content">购买可得{{minPoint}}积分起</div>
                                <div class="myPoint">已有积分：{{totalPoint || 0}}</div>
                            </div>

                        </div>
                        <!-- 优惠 -->
                        <div class="sale-promotion-wrapper" v-if="genericCouponList && genericCouponList.length !== 0">
                            <div class="title">优惠券</div>
                            <div class="couponcontentshell">

                                <div :class="{'coupon-diabled': item.receiveCouponNum === 0, coupon:true, clearfix:true}" v-for="item in genericCouponList" :key='item.index'>
                                    <div class="couponcontent">
                                        <p class="num" v-if="item.couponType === '5'">
                                            <span>{{item.faceAmount}}</span>折
                                            <span class='numFonts'>优惠券</span>
                                        </p>
                                        <p class="num" v-else>￥
                                            <span>{{item.faceAmount}}</span>
                                            <span class='numFonts'>优惠券</span>
                                        </p>
                                        <p class="limit">满{{item.thresholdAmount}}元可使用</p>
                                        <span class="period" v-if="item.couponValidityType === '2' && item.couponValidityStart && item.couponValidityEnd">有效期:{{item.couponValidityStart.substring(0,10)}}~{{item.couponValidityEnd.substring(0,10)}}</span>
                                        <span class="period" v-if="item.couponValidityType === '1'">领取后{{item.couponValidityDay}}天内有效</span>
                                    </div>
                                    <div class="couponbtn" @click="receiveCoupon(item)">
                                        <span>立即领取</span>
                                    </div>
                                    <!-- <div class="couponbtn" v-if="item.receiveCouponNum === 0">
                                        <span>已经领取</span>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="clickoff" @click.stop="clickoffCoupon()">完成</div>
                </van-popup>
            </div>
        </div>
        <div class="parameter" v-show="showParameter">
            <van-popup v-model="showParameter" position="bottom" :close-on-click-overlay="closeOnClickOverlay1">
                <div class="paratitle">产品参数</div>
                <div class="attrsshell">
                    <div class="attrs clearfix" v-for="item in productParameterList" :key="item.index">
                        <span class="attr">{{item.key}}</span>
                        <span class="content">{{item.value}}</span>
                    </div>
                </div>
                <div class="clickoff" @click.stop="clickoffbtn()">完成</div>
            </van-popup>
        </div>
        <van-popup v-model="shadowShow" class='shadow'>
            <div class='shadow' v-if='shadowShow'>
                <img :src="shadowPicZx" alt="" class='shadowPicZx'>
                <img :src="shadowPicZxText" alt="" class='shadowPicZxText'>
                <div class='shadowBtn'>
                    <div>
                        <van-button type="primary" class='btnColor2' @click="cancelShadow">取消</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-image-preview v-model="detailImgShow" :images="detailBigImg" :showIndex="false">
        </van-image-preview>
        <!-- <van-popup v-model="videoShow" class="video-show-pop">
            <video id="swiperBigVideo" controls preload x5-video-player-type="h5-page">
                <source :src="swiperBigVideoSource" type="video/mp4">
            </video>
        </van-popup> -->
    </div>
    <div v-else class="no-product">
        <img  src="../assets/img/myCenter/noProduct.png" alt="">
        <div>商品已下架</div>
    </div>

    <!-- <wxShareLoading></wxShareLoading> -->
</div>
</template>

<script>
import Vue from 'vue';
// import Aliplayer from '@/utils/player/aliplayer.js';
import {
    Toast,
    Lazyload
} from 'vant';
import evaluationCommon from '@/components/common/evaluationCommon';
import listBottom from '@/components/common/listBottom';
import integralDeduction from '@/components/common/integralDeduction';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import {
    wxCircle,
    wxFriends
} from '@/base/share.js';
import {
    mapActions, mapGetters
} from 'vuex';
Vue.use(Lazyload, Toast);
export default {
    components: {
        evaluationCommon,
        listBottom,
        integralDeduction
    },
    name: 'goodsdetail',
    computed: {
        ...mapGetters(
            ['merchantInfo']
        ),
        videoBg() {
            return {
                background: 'url(' + this.productImages[0] + ') no-repeat center',
                backgroundSize: 'contain',
                width: '100%',
                height: '100%'
            };
        },
        showAllCoupon() {
            // 优惠 积分 套餐 !this.$common.isEmptyObject(this.goodsdetildata)
            return this.couponList.length !== 0 || this.activityList.length !== 0 || this.minPoint || (this.goodsdetildata && ((this.goodsdetildata.genericCouponList && this.goodsdetildata.genericCouponList.length !== 0) || this.goodsdetildata.groupProductQuantity));
        }

    },
    data() {
        return {
            noProduct: false,
            detailBigImg: [],
            detailImgShow: false,
            detailVideoSource: '',
            swiperBigVideoSource: '',
            // 商品是否有轮播视频， 接口获取
            hasSwiperVideo: false,
            hasDetailVideo: false,
            // merchantInfo: {},
            videoShow: false,
            createOnce: true,
            detailPlayer: {},
            swiperBigVideoCover: '',
            // 轮播视频上一次播放的状态
            lastStatus: '',
            // 轮播 tag被选中的对象名称  'player'视频 'photo'图片
            clickTagName: 'player',
            accountInvitationCode: '',
            link: '',
            // 规格数量
            specificationNum: 0,
            selectedSku: {},
            totalPoint: '',
            minPoint: '',
            ajaxShow: false,
            contactCustomer: '',
            current: 0,
            goodsdetildata: {},
            productId: '',
            active: 2,
            icon: {
                active: require('../assets/img/goods/collectioned@3x.png'),
                normal: require('../assets/img/goods/collection@3x.png'),
                kf: require('../assets/img/goods/kefu@3x.png')

            },
            showservice: false, // 显示服务
            showCoupon: false, // 显示优惠
            showBase: false,
            showParameter: false, // 显示参数
            quota: 0,
            quotaUsed: 0,
            resetStepperOnHide: false,
            resetSelectedSkuOnHide: false,
            closeOnClickOverlay: true,
            closeOnClickOverlay1: true,
            closeOnClickOverlay2: true,
            disableStepperInput: false,
            messageConfig: {},
            goodsId: '00001',
            sku: {},
            goods: {
                picture: require('../assets/img/goods/collection.png'),
                title: ''
            },
            productParameterList: [],
            productImages: [],
            introduction: [], // 详情图
            productImage: [],
            productComment: {},
            skuData: {},
            isgocart: 0,
            activityList: [], // 活动列表
            activityListnew: [], // 活动列表
            activityListFirst: '', // 活动列表第一个
            couponList: [], // 活动优惠券列表
            genericCouponList: [], // 优惠券列表
            couponNameList: [], // 活动的名字
            activityFirst: '', // 第一个优惠券的名字
            selectedStyles: [],
            selectedStylesString: '',
            showSelectName: '',
            customStepperConfig: {
                // 自定义步进器超过限制时的回调
                handleOverLimit: (data) => {
                    const {
                        action
                    } = data;

                    if (action === 'minus') {

                    }
                }
            },
            count: 1,
            initialSku: {},
            finishedOk: false,
            shadowShow: false,
            shadowPicZx: require('@/assets/img/goods/planzx.png'),
            shadowPicZxText: require('@/assets/img/goods/planText.png'),
            retailStoreProductFlag: null,
            spreadingCode: '',
            shareUrl: '',
            normalUrl: '',
            merchantCode: ''
        };
    },
    esvReady: function () {
        console.log('aaas');
        this.ESVStorage.getSavedValue('isShowBase', (data) => {
            if (data === false) {
                this.showBase = data;
            }
        });
        this.ESVStorage.putSavedValue('isShowBase', true);
        // TODO 不知道为什么的回退
        // window.addEventListener('popstate', this.goBack, false);
    },
    esvShow: function () {
        let tagIndex;
        let id;
        let list;
        let dataDetails;
        let orderCode;
        this.oldReady();
        this.setAddressBeginId('-1'); // 清空地址id
        this.ESVStorage.getSavedValue('tagIndex', (data) => {
            tagIndex = data;
        });
        this.ESVStorage.getSavedValue('id', (data) => {
            id = data;
        });
        this.ESVStorage.getSavedValue('list', (data) => {
            list = data !== '' ? data : [];
        });
        this.ESVStorage.getSavedValue('dataDetails', (data) => {
            dataDetails = data !== null ? data : {};
        });
        this.ESVStorage.getSavedValue('orderCode', (data) => {
            orderCode = data !== null ? data : {};
        });

        this.ESVStorage.removeSavedValue('invoiceArr');
        this.ESVStorage.removeSavedValue('fullArrText');
        this.ESVStorage.removeSavedValue('objCoupon');
        this.ESVStorage.removeSavedValue('fullArr');
        this.ESVStorage.removeSavedValue('remarkArr');
        this.ESVStorage.removeSavedValue('invoiceIndex');

        this.ESVStorage.putSavedValue('goodsId', this.productId);
        this.ESVStorage.putSavedValue('tagIndex', tagIndex);
        this.ESVStorage.putSavedValue('id', id);
        this.ESVStorage.putSavedValue('list', list);
        this.ESVStorage.putSavedValue('dataDetails', dataDetails);
        this.ESVStorage.putSavedValue('orderCode', orderCode);

        // this.initPlayer();
    },
    methods: {
        ...mapActions(['setAddressBeginId']),
        // swiperBigVideoInit(player) {
        //     console.log('点击视频加载完毕');

        //     this.createOnce = false;
        //     this.popPlayer = player;
        // },
        // detailVideoInit(player) {
        //     console.log('详情视频加载完毕');
        //     this.detailPlayer = player;
        // },
        showBigDetaileImg(img) {
            console.log(img);
            this.detailBigImg = [img];
            this.detailImgShow = true;
        },
        clickPlay() {
            this.videoShow = true;
        },
        // 点击swiper视频或图片按钮
        changeSwiper(name) {
            this.clickTagName = name;
            if (name === 'photo') {
                this.current = 1;
                this.$refs.proSwiper.swipeTo(1);
            } else {
                this.current = 0;
                this.$refs.proSwiper.swipeTo(0);
            }
        },
        // 是否登录
        queryMemberLoginFlag() {
            this.$doRequest({
                url: '/account/queryMemberLoginFlag',
                params: {},
                before: () => {
                    this.loading = toastLoading();
                },
                complete: () => {

                }
            },
            (data) => {
                console.log(data.result, this.merchantCode);

                if (data.result) {
                    this.queryMemberAccount();
                } else {
                    this.normalUrl = window.location.href.split('#')[0] + '#/opGoodsdetail' + '?productId=' + this.productId;
                    this.getShortOauthUrl(this.normalUrl, this.merchantCode);
                }
            },
            data => {
                clearToastLoading(this.loading);
            }
            );
        },
        queryMemberAccount() {
            this.$doRequest({
                url: '/account/queryMemberAccount',
                params: {},
                before: () => {
                    this.loading = toastLoading();
                },
                complete: () => {
                    // clearToastLoading(this.loading);
                }
            },
            (data) => {
                this.shareUrl = window.location.href.split('#')[0] + '#/opGoodsdetail' + '?code=' + data.result.accountInvitationCode + '&productId=' + this.productId;
                this.normalUrl = window.location.href.split('#')[0] + '#/opGoodsdetail' + '?productId=' + this.productId;
                this.accountInvitationCode = data.result.accountInvitationCode;
                if (this.retailStoreProductFlag === 1) {
                    this.getShortOauthUrl(this.shareUrl, this.merchantCode);
                } else {
                    this.getShortOauthUrl(this.normalUrl, this.merchantCode);
                }
            },
            data => {
                clearToastLoading(this.loading);
            }
            );
        },
        // 原来写在ready的代码
        oldReady() {
            const ths = this;
            this.productId = this.ESVBase.getPramVal('productId');
            if (!this.productId) {
                ths.ESVStorage.getSavedValue('goodsId', (data) => {
                    ths.productId = data;
                });
            }
            this.spreadingCode = this.ESVBase.getPramVal('code');
            document.title = '商品详情';
            this.retailStoreProductFlag = this.$route.params.retailStoreProductFlag;

            let channelType = 'WECHAT';
            this.ESVStorage.getSessionValue('channelType', (data) => {
                channelType = data || '';
            });
            if (channelType.indexOf('APP') < 0) {
                ths.contactCustomerLink();
            }
            ths.queryData();
            this.ESVStorage.getSessionValue('baseSession', (data) => {
                const {
                    merchantCode
                } = {
                    ...data
                };

                if (merchantCode) {
                    this.merchantCode = merchantCode;
                    console.log('有缓存情况商户信息', this.merchantCode, this.merchantInfo);
                    this.queryMemberLoginFlag();
                } else {
                    this.getMerchantInfo();
                }
            });
        },
        // 将要分享的链接转为短链接
        getShortOauthUrl(url, merchantCode) {
            const ths = this;
            console.log(url, 'shortUrl');

            ths.$doRequest({
                url: '/oauth/getShortOauthUrl',
                params: {
                    url,
                    merchantCode
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.link = data.result;
                console.log(ths.link);

                ths.onMenuFriend(ths.link);
            }
            );
        },
        getMerchantInfo() {
            // let ths = this;
            // ths.$doRequest({
            //     url: '/merchant/getMerchantInfo',
            //     params: {},
            //     before: function () {
            //         ths.loading = toastLoading();
            //     },
            //     complete: function () {
            //         // clearToastLoading(ths.loading);
            //     }
            // },
            // function (data) {
            // this.merchantInfo = data.result;
            this.merchantCode = this.merchantInfo.merchantCode;
            setTimeout(() => {
                console.log('没有缓存情况商户信息', this.merchantCode, this.merchantInfo);
            }, 1000);
            console.log('没有缓存情况商户信息', this.merchantCode, this.merchantInfo);
            this.queryMemberLoginFlag();
            // },
            // data => {
            //     clearToastLoading(ths.loading);
            // }
            // );
        },
        goBack() {
            const ths = this;
            console.log('回退');
            ths.showCoupon = false;
            ths.showParameter = false;
            ths.showBase = false;
            console.log(ths.showBase);
        },
        goService() {
            this.ESVStorage.putSavedValue('isShowBase', false);
        },
        getNameHeight() {
            // console.log(document.querySelector('.van-ellipsis').offsetHeight);
            let title = {};
            if (this.count === 1) {
                const parent = document.querySelector('.van-sku-header__goods-info');
                const title = document.createElement('div');
                title.className = 'copy';

                parent.appendChild(title);
            }
            title = title || document.querySelector('.copy');
            console.log(title);
            console.log(title.innerText);
            console.log(this.goods.title);
            title.innerText = this.goods.title;
            console.log(title.innerText);
        },
        clickOverlay2() {
            this.showCoupon = false;
        },
        goevaluation(item) {
            const ths = this;
            ths.esvOpenPage({
                name: 'OPEvaluation',
                params: {
                    goodsId: item
                }
            });
        },
        getUrlParam(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },
        // 查询链接
        contactCustomerLink() {
            const ths = this;
            const params = {

            };
            if (ths.$route.query.productId) {
                // let token = ths.getPramVal('token');
                // params.token = token;
            }
            ths.$doRequest({
                url: '/merchant/contactCustomer',
                params: params
                // before: function () {
                //     ths.loading = toastLoading();
                // },
                // complete: function () {
                //     clearToastLoading(ths.loading);
                // }
            },
            function (data) {
                ths.contactCustomer = data.result;
            }
            );
        },
        getPramVal(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const str =
                window.location.href.indexOf('?') === -1
                    ? ''
                    : window.location.href.slice(
                        window.location.href.indexOf('?'),
                        window.location.href.length
                    );
            const r = str.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        getPramVal2(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const str =
                window.location.href.indexOf('?') === -1
                    ? ''
                    : window.location.href.slice(
                        window.location.href.lastIndexOf('?'),
                        window.location.href.length
                    );
            const r = str.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        queryData() {
            const ths = this;
            const params = {
                productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId
            };
            ths.$doRequest({
                url: '/product/queryProductDetail',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            (data) => {
                ths.ajaxShow = true;
                ths.goodsdetildata = {
                    'activityList': [
                        {
                            'accountLevelRange': 'null至null',
                            'activityCurrentStatus': 2,
                            'activityCurrentStatusDesc': '促销中',
                            'activityEndTime': '2021-01-31 00:00:00',
                            'activityLogo': 'http://eslink-operation-qa.oss-cn-beijing.aliyuncs.com/20210119173448041407.jpg',
                            'activityStartTime': '2021-01-19 00:00:00',
                            'activityStatus': 2,
                            'activityStatusDesc': '有效',
                            'activityTimeRange': '2021-01-19 00:00:00至2021-01-31 00:00:00',
                            'activityTitle': '测试商城活动',
                            'activityType': 2,
                            'activityTypeDesc': '满减',
                            'createTime': '2021-01-19 17:35:09',
                            'id': 368,
                            'meetReduceActivity': {
                                'activityId': 368,
                                'createTime': '2021-01-19 17:35:09',
                                'id': 51,
                                'meetReduceActivityType': 1,
                                'meetReduceActivityTypeDesc': '满额',
                                'merchantCode': '0185',
                                'preferentialConfigStr': '满1元，订单减1元；',
                                'preferentialConfigs': [
                                    {
                                        'cash': '1',
                                        'meet': '1',
                                        'discount': '0',
                                        'cashRequiredFlag': 'true',
                                        'couponTemplateCode': '20210119173509776725',
                                        'discountRequiredFlag': 'false'
                                    }
                                ],
                                'rangeType': 1,
                                'rangeTypeDesc': '全部商品',
                                'subcompanyCode': '018501',
                                'updateTime': '2021-01-19 17:35:09'
                            },
                            'merchantCode': '0185',
                            'subcompanyCode': '018501',
                            'updateTime': '2021-01-19 17:35:09',
                            'useCouponDesc': '是',
                            'useCouponFlag': 1,
                            'useCouponFlagDesc': '是'
                        }
                    ],
                    'businessType': 2,
                    'businessTypeDesc': '直运',
                    'caption': '测试1',
                    'categoryArr': '512,513,514',
                    'categoryName': '三级分类',
                    'collectStatus': 2,
                    'contentNum': 0,
                    'couponList': [
                        {
                            'activityId': 368,
                            'couponIssuedEnd': '2021-01-31 00:00:00',
                            'couponIssuedMethod': '2',
                            'couponIssuedMethodStr': '活动发放',
                            'couponIssuedStart': '2021-01-19 00:00:00',
                            'couponName': '测试商城活动满1减1',
                            'couponSimpleName': '满1减1',
                            'couponTemplateCode': '20210119173509776725',
                            'couponTemplateProgress': '进行中',
                            'couponType': '3',
                            'couponTypeStr': '活动券',
                            'couponValidityDay': 1,
                            'couponValidityType': '1',
                            'couponValidityTypeStr': '有效天数',
                            'createTime': '2021-01-19 17:35:09',
                            'displayFlag': 1,
                            'displayFlagStr': '是',
                            'faceAmount': 1,
                            'id': 475,
                            'issuedQuantity': 10,
                            'merchantCode': '0185',
                            'productScopeType': '1',
                            'productScopeTypeStr': '全部商品',
                            'receiveCouponNum': 5,
                            'receiveCouponUrl': 'http://etbc.hw-qa.eslink.net.cn/operation-local/oauth/oauthUrl?url=http://etbc.hw-qa.eslink.net.cn/operation-local/%23%2FOPreceiveCoupon%3FmerchantCode=0185%26couponTemplateCode=20210119173509776725&merchantCode=0185',
                            'status': '1',
                            'statusStr': '有效',
                            'stockQuantity': 9,
                            'subcompanyCode': '018501',
                            'thresholdAmount': 1,
                            'updateTime': '2021-01-19 17:35:55',
                            'userLimit': 5
                        }
                    ],
                    'createdDate': '2020-05-25 20:29:12',
                    'deliveryTemplateId': 29,
                    'distributionChannel': '1,2,3',
                    'groupProductQuantity': 2,
                    'image': 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20200525202843945672.jpg',
                    'introduction': 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20200525202901981866.jpg',
                    'isBuyLimit': 2,
                    'isBuyLimitDesc': '否',
                    'isMarketable': 2,
                    'isMarketableStr': '上架',
                    'lastModifiedDate': '2020-06-18 11:00:46',
                    'logisticsType': 'EXPRESS_DELIVERY',
                    'logisticsTypeDesc': '快递',
                    'maxDeductionAmount': 0.5,
                    'maxPrice': 2,
                    'maxStoreProfit': 0,
                    'merchantCode': '0185',
                    'minPoint': 15,
                    'minPrice': 2,
                    'name': '测试商品卡',
                    'productBaseImage': 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20200525202853477223.jpg',
                    'productCarouselVedio': '',
                    'productDetailVedio': '',
                    'productId': 1253,
                    'productImages': 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20200525202843945672.jpg',
                    'productParameterList': [
                        {
                            'createTime': '2020-05-25 20:30:48',
                            'id': 558,
                            'key': '型号',
                            'merchantCode': '0185',
                            'productId': 1253,
                            'updateTime': '2020-05-25 20:30:48',
                            'value': '001'
                        }
                    ],
                    'productRate': 0,
                    'productStatus': 1,
                    'productStatusDesc': '启用',
                    'productSynchroFlag': 1,
                    'productUrl': 'http://etbc.hw-qa.eslink.net.cn/operation-local/oauth/oauthUrl?url=http://etbc.hw-qa.eslink.net.cn/operation-local/%23%2FOPGoodsdetail%3FmerchantCode=0185%26productId=1253&merchantCode=0185',
                    'rebateRate': '0',
                    'resultRebateRate': 0,
                    'retailStoreProductFlag': 1,
                    'salesNum': 10,
                    'sku': {
                        'tree': [
                            {
                                'v': [
                                    {
                                        'name': '白色',
                                        'id': 2663
                                    },
                                    {
                                        'name': '红色',
                                        'id': 2664
                                    }
                                ],
                                'k_s': 's1',
                                'k': '颜色'
                            }
                        ],
                        'list': [
                            {
                                'image': 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20200525203613599361.jpg',
                                'id': '202005252036220185',
                                'price': 2,
                                's1': 2663,
                                'stock_num': 133
                            }
                        ]
                    },
                    'storeProductCategoryId': 575,
                    'supplierId': 104,
                    'supplierName': '电器供应商测试1',
                    'totalInventory': 133,
                    'totalPoint': 0,
                    'type': 1,
                    'typeStr': '普通商品',
                    'weight': 2
                };

                for (const k in data.result) {
                    if (Object.hasOwnProperty.call(data.result, k)) {
                        const item = data.result[k];
                        ths.$set(ths.goodsdetildata, k, item);
                    }
                }

               // console.log(ths.goodsdetildata);
                // 是否有视频
                ths.hasSwiperVideo = !!ths.goodsdetildata.productCarouselVedio;
                ths.hasDetailVideo = !!ths.goodsdetildata.productDetailVedio;

                if (ths.hasDetailVideo) {
                    // ths.detailVideo.source = ths.goodsdetildata.productDetailVedio;
                    ths.detailVideoSource = ths.goodsdetildata.productDetailVedio;
                }
                if (ths.hasSwiperVideo) {
                    ths.swiperBigVideoSource = ths.goodsdetildata.productCarouselVedio;
                }
                ths.$nextTick(() => {
                    ths.detailPlayer = document.querySelector('#detailVideo');
                    ths.popPlayer = document.querySelector('#swiperBigVideo');
                    ths.addPlayListener();
                    console.dir(ths.detailPlayer);
                });
                // ths.goodsdetildata.marketPrice = '44';
                if (ths.goodsdetildata.isBuyLimit === 1) {
                    ths.quota = ths.goodsdetildata.buyLimit;
                    ths.customStepperConfig.quotaText = '(每次限购' + ths.goodsdetildata.buyLimit + '件)';
                }
                if (ths.goodsdetildata.minPoint) {
                    ths.minPoint = ths.goodsdetildata.minPoint;
                }
                if (ths.goodsdetildata.minPoint) {
                    ths.totalPoint = ths.goodsdetildata.totalPoint;
                }
                // ths.goods.title = '请选择 颜色分类';
                ths.goods.picture = data.result.productImages.split(',')[0];
                ths.productParameterList = data.result.productParameterList
                    ? data.result.productParameterList : [];
                ths.productImages = data.result.productImages
                    ? data.result.productImages.split(',') : [];
                ths.introduction = data.result.introduction
                    ? data.result.introduction.split(',') : [];
                // 是否请求成功
                ths.finishedOk = true;
                ths.productComment = data.result.productComment
                    ? data.result.productComment : {};
                ths.productImage =
                        data.result.productComment &&
                        data.result.productComment.productImage
                            ? data.result.productComment.productImage.split(',') : [];
                ths.active = data.result.collectStatus
                    ? data.result.collectStatus
                    : 1;
                ths.activityList = data.result.activityList
                    ? data.result.activityList : [];
                ths.couponList = data.result.couponList
                    ? data.result.couponList : [];
                ths.genericCouponList = data.result.genericCouponList
                    ? data.result.genericCouponList : [];
                ths.couponNameList = [];
                if (data.result.couponList && data.result.couponList.length >= 1) {
                    data.result.couponList.forEach((coupon, index) => {
                        if (index >= 2) {
                            return false;
                        }
                        ths.couponNameList.push(coupon.couponSimpleName);
                    });
                }
                ths.sku = data.result.sku ? data.result.sku : {};
                ths.specificationNum = ths.sku.tree.length;
                if (data.result.sku && data.result.sku.list) {
                    for (
                        var j = 0, len = ths.sku.list.length; j < len; j++
                    ) {
                        ths.sku.list[j].price = ths.sku.list[j].price * 100;
                    }
                    const minPrice = ths.ESVBase.numberTofixed(ths.goodsdetildata.minPrice);
                    const maxPrice = ths.ESVBase.numberTofixed(ths.goodsdetildata.maxPrice);
                    if (ths.goodsdetildata.maxPrice === ths.goodsdetildata.minPrice) {
                        ths.$set(ths.sku, 'price', minPrice);
                    } else {
                        ths.$set(ths.sku, 'price', `${minPrice}-${maxPrice}`);
                    }
                    ths.$set(
                        ths.sku,
                        'stock_num',
                        ths.goodsdetildata.totalInventory
                    );
                }
                if (data.result.sku && data.result.sku.tree) {
                    let title = '';
                    data.result.sku.tree.forEach((item) => {
                        title += ',' + item.k;
                    });
                    ths.goods.title = '请选择 ' + title.substring(1);
                }
                if (
                    data.result.activityList &&
                        data.result.activityList.length > 0
                ) {
                    ths.activityListnew = [];
                    if (
                        ths.activityList.length > 0 && ths.activityList[0].meetReduceActivity &&
                            ths.activityList[0].meetReduceActivity
                                .preferentialConfigs
                    ) {
                        ths.activityList.forEach((valueold, index) => {
                            const arr = [];
                            let s = '';
                            let time = '';
                            valueold.meetReduceActivity.preferentialConfigs.forEach(
                                (value, index) => {
                                    s = '';
                                    s += '满' + value.meet;
                                    if (
                                        valueold.meetReduceActivity
                                            .meetReduceActivityTypeDesc ===
                                            '满件'
                                    ) {
                                        s += '件';
                                    }
                                    if (value.cash && value.cash !== '0') {
                                        s += '减' + value.cash + '元';
                                    }
                                    if (value.discount && value.discount !== '0') {
                                        s +=
                                                '打' +
                                                value.discount / 10 +
                                                '折';
                                    }
                                    s =
                                            s.length >= 18
                                                ? s.substring(0, 18)
                                                : s;
                                    arr.push(s);
                                    if (arr.length >= 2) {
                                        return false;
                                    }
                                }
                            );
                            if (
                                valueold.activityStartTime &&
                                    valueold.activityEndTime
                            ) {
                                time =
                                        valueold.activityStartTime.substring(
                                            0,
                                            10
                                        ) +
                                        '~' +
                                        valueold.activityEndTime.substring(
                                            0,
                                            10
                                        );
                            }
                            var st = {
                                actname: arr,
                                timerange: time,
                                id: valueold.id
                            };
                            ths.activityListnew.push(st);
                        });
                    }
                    ths.activityListFirst = ths.activityListnew[0].actname;
                    // console.log(ths.activityListFirst);
                    ths.activityListFirst.forEach((list, index) => {
                        const newlist = list.length >= 17 ? list.substring(0, 17) : list;
                        return newlist;
                    });
                    // console.log(ths.activityListFirst);
                    // ths.activityListFirst =
                    //         ths.activityListFirst.length >= 17
                    //             ? ths.activityListFirst.substring(0, 17)
                    //             : ths.activityListFirst;
                }
            },
            data => {
                this.$toast(data.message);
                this.noProduct = true;
            }
            );
        },
        onChange(index) {
            this.current = index;
            if (this.hasSwiperVideo) {
                if (index === 0) {
                    this.clickTagName = 'player';
                } else {
                    this.clickTagName = 'photo';
                    this.popPlayer.pause();
                }
            }
        },
        addPlayListener() {
            const ths = this;
            this.popPlayer && this.popPlayer.addEventListener('play', function (e) {
                console.log('提示该视频正在播放中');
                console.log(e);
                ths.detailPlayer.pause();
            });
            this.detailPlayer && this.detailPlayer.addEventListener('play', function (e) {
                console.log('提示该视频正在播放中');
                console.log(e);
                ths.popPlayer.pause();
            });
        },
        // 调出商品服务
        service() {
            this.showservice = true;
        },
        clickoffservice() {
            this.showservice = false;
        },
        // 调出优惠活动 优惠券
        Coupon() {
            this.showCoupon = true;
        },
        clickoffCoupon() {
            this.showCoupon = false;
        },
        // 跳转到活动页面
        goActivity(item) {
            console.log(item);

            const ths = this;
            ths.$doRequest({
                url: '/activity/queryActivityById',
                params: {
                    id: item.id
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.ESVStorage.putSavedValue(
                    'activityDetails',
                    data.result
                );
                ths.esvOpenPage('OPFullActivitys');
            }
            );
        },
        // 领取优惠券
        receiveCoupon(item) {
            const ths = this;
            if (item.receiveCouponNum !== 0) {
                const { couponTemplateCode, couponType } = item;
                ths.$doRequest({
                    url: '/coupon/receiveCoupon',
                    params: {
                        productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId,
                        couponTemplateCode,
                        couponType
                    },
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        if (data.result.receiveCouponNum >= 1) {
                            Toast(
                                '还可领取' + data.result.receiveCouponNum + '张'
                            );
                        } else {
                            ths.queryData();
                            Toast('领取成功');
                        }
                    }
                }
                );
            } else {
                this.$toast('不能领取啦~');
            }
        },
        // 调出商品参数
        parame() {
            this.showParameter = true;
        },
        clickoffbtn() {
            this.showParameter = false;
        },
        // 调出商品规格
        specifications() {
            // debugger;
            this.showBase = true;

            // let skuData = this.$refs.vanSku.getSkuData();
            // let selectedSku = {};
            this.selectedStyles = [];
            this.showSelectName = '';
            this.sku.tree.forEach((value, index) => {
                // debugger;
                let flag = true;
                if (!this.selectedSku[value.k_s] && (value.v.length > 1 || this.count !== 1 || this.goodsdetildata.totalInventory === 0)) {
                    this.showSelectName += ',' + value.k;
                    flag = false;
                }
                value.v.forEach((valueNew, index) => {
                    // debugger;
                    if (valueNew.id === this.selectedSku[value.k_s] || (flag && this.count === 1 && this.goodsdetildata.totalInventory !== 0)) {
                        this.selectedStyles.push(valueNew.name);
                    }
                });
            });
            this.changeImage(this.sku.list, this.selectedSku);
            if (this.showSelectName) {
                this.goods.title = '请选择 ' + this.showSelectName.substring(1);
            } else {
                let title = '';
                this.selectedStyles.forEach((item) => {
                    title += '“' + item + '” ';
                });
                this.goods.title = '已选: ' + title;
            }
            this.$nextTick(() => {
                this.getNameHeight();
            });
            // console.log(skuData);
        },
        gohome() {
            const ths = this;
            ths.esvOpenPage('OPHomenew');
        },
        collection() {
            const ths = this;
            if (ths.active === 1) {
                ths.$doRequest({
                    url: '/collection/cancelMemberShippingCollection',
                    params: {
                        productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId

                    },
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '10001003') {
                        ths.esvOpenPage({
                            name: 'OPLogin'
                        });
                    } else if (data.responseCode === '100000') {
                        ths.active = 2;
                        Toast('取消收藏');
                    } else {
                        Toast(data.message);
                    }
                }
                );
            } else if (ths.active === 2) {
                ths.$doRequest({
                    url: '/collection/saveMemberShippingCollection',
                    params: {
                        productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId

                    },
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        ths.active = 1;
                        Toast('已收藏');
                    } else {
                        Toast(data.message);
                    }
                }
                );
            }
        },
        gocart() {
            this.isgocart = 1;
            this.showBase = true;
            this.specifications();
        },
        gobuy() {
            this.isgocart = 2;
            this.showBase = true;
            this.specifications();
        },
        onAddCartClicked(skuData) {
            const ths = this;
            ths.skuData = skuData;
            const params = {
                productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId,
                skuCode: skuData.selectedSkuComb.id,
                quantity: skuData.selectedNum
            };
            if (this.spreadingCode) {
                params.spreadingCode = ths.spreadingCode;
            }
            ths.$doRequest({
                url: '/cart/addMemberShippingCart',
                params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                    ths.isgocart = 0;
                }
            },
            function (data) {
                if (data.responseCode === '10001003') {
                    ths.esvOpenPage({
                        name: 'OPLogin'
                    });
                } else if (data.responseCode === '100000') {
                    ths.showBase = false;
                    Toast('添加成功，在购物车等亲~');
                } else {
                    Toast(data.message);
                }
            }
            );
        },
        /* 从规格进购物车或购买 */
        onBuyClicked(skuData) {
            const ths = this;
            ths.skuData = skuData;
            const params = {
                productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId,
                skuCode: skuData.selectedSkuComb.id,
                quantity: skuData.selectedNum

            };
            if (this.spreadingCode) {
                params.spreadingCode = ths.spreadingCode;
            }
            const activityId = (ths.activityList[0] && ths.activityList[0].meetReduceActivity && ths.activityList[0].meetReduceActivity.activityId) || -1;
            if (ths.isgocart === 1) {
                ths.loading = true;
                ths.$doRequest({
                    url: '/cart/addMemberShippingCart',
                    params,
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                        ths.isgocart = 0;
                    }
                },
                function (data) {
                    if (data.responseCode === '10001003') {
                        ths.esvOpenPage({
                            name: 'OPLogin'
                        });
                    } else if (data.responseCode === '100000') {
                        ths.showBase = false;
                        Toast('添加成功，在购物车等亲~');
                    } else {
                        Toast(data.message);
                    }
                }
                );
            } else if (ths.isgocart === 2 || ths.isgocart === 0) {
                ths.$doRequest({
                    url: '/order/settlement',
                    params: {
                        orderJsonList: JSON.stringify([{
                            productId: ths.$route.query.productId ? ths.$route.query.productId : ths.productId,
                            skuCode: skuData.selectedSkuComb.id,
                            quantity: skuData.selectedNum,
                            spreadingCode: ths.spreadingCode,
                            activityId: activityId
                        }]),
                        usePointFlag: 1,
                        participate: 1

                    },
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                        ths.isgocart = 0;
                    }
                },
                function (data) {
                    if (data.responseCode === '10001003') {
                        ths.esvOpenPage({
                            name: 'OPLogin'
                        });
                    }
                    const result = data.result;
                    result.orderRespDTOLis && result.orderRespDTOList.forEach((item, index) => {
                        if (item.value.activeList.length > 0) {
                            item.value.activeList.push({
                                activityId: -1,
                                activityTitle: '不使用活动',
                                activityType: 4
                            });
                        }
                    });

                    ths.ESVStorage.putSavedValue(
                        'requireInfo',
                        result
                    );
                    ths.ESVStorage.putSavedValue(
                        'requireInfoall',
                        result
                    );
                    const arr = [];
                    ths.ESVStorage.putSavedValue('invoiceArr', arr);
                    ths.ESVStorage.putSavedValue('submitType', '1');
                    // 地址
                    if (data.result.address && data.result.address.id) {
                        ths.ESVStorage.putSavedValue(
                            'addressBegin',
                            data.result.address.id
                        );
                    }
                    ths.esvOpenPage({
                        name: 'OPConfirmOrder'
                    });
                }
                );
            } else {
                ths.showBase = false;
            }
        },
        /* 切换规格类目时触发 改变选择显示规格 */
        onSkuSelected(skudatas, selectedSku) {
            console.log(selectedSku);
            console.log(skudatas);
            this.initialSku = skudatas.selectedSku;
            // console.log(skudatas, 'skudatas');
            const ths = this;
            this.count = 2;
            this.selectedSku = skudatas.selectedSku;
            // let mark = true;
            ths.selectedStyles.length = 0;
            ths.showSelectName = '';
            ths.sku.tree.forEach((value, index) => {
                if (!skudatas.selectedSku[value.k_s]) {
                    ths.showSelectName += ',' + value.k;
                }
                value.v.forEach((valueNew, index) => {
                    if (valueNew.id === skudatas.selectedSku[value.k_s]) {
                        ths.selectedStyles.push(valueNew.name);
                    }
                });
            });

            ths.changeImage(ths.sku.list, skudatas.selectedSku);
            if (ths.showSelectName) {
                ths.goods.title = '请选择 ' + ths.showSelectName.substring(1);
            } else {
                let title = '';
                ths.selectedStyles.forEach((item) => {
                    title += '“' + item + '” ';
                });
                ths.goods.title = '已选: ' + title;
            }
            this.getNameHeight();
        },
        changeImage(list1, list2) {
            let mark = true;
            const ths = this;
            for (let i = 0; i < list1.length; i++) {
                mark = ths.isObjectValueEqual(list1[i], list2);
                if (mark) {
                    ths.goods.picture = list1[i].image;
                    break;
                }
            }
            if (!mark) {
                ths.goods.picture = ths.productImages[0];
            }
        },
        // 比较两个对象属性是否相等
        isObjectValueEqual(a, b) {
            // let aProps = Object.getOwnPropertyNames(a);
            // let bProps = Object.getOwnPropertyNames(b);
            // // if (aProps.length !== bProps.length) {
            // //     return false;
            // // }
            // let len = bProps.length - 1;
            // bProps.splice(len, 1);

            // for (let i = 0; i < bProps.length; i++) {
            //     let propName = bProps[i];
            //     if (a[propName] !== b[propName]) {
            //         return false;
            //     }
            // }
            for (const attr in b) {
                if (b[attr] !== a[attr]) {
                    return false;
                }
            }
            return true;
        },
        gocartpage() {
            const ths = this;
            ths.esvOpenPage({
                name: 'OPShoppingcart',
                params: {}
            });
        },
        selectedString() {
            if (this.selectedStyles.length >= 1 && this.specificationNum === this.selectedStyles.length) {
                var s2 = '已选:';
                this.selectedStyles.forEach(item => {
                    s2 += '"';
                    s2 += item;
                    s2 += '" ';
                });
            }
            this.selectedStylesString = s2;
        },
        fxDetailsUrlClick() {
            this.isClick = true;
            // this.queryMemberAccount();
            this.getShortOauthUrl(this.shareUrl, this.merchantCode);
            this.$nextTick(() => {
                this.shadowShow = true;
            });
            // this.onMenuFriend();
        },
        onMenuFriend(link) {
            console.log('点击分享');
            wxCircle(this.goodsdetildata.name, link, this.goodsdetildata.image, 'goods');
            wxFriends(this.goodsdetildata.name, this.goodsdetildata.caption || '', link, this.goodsdetildata.image);
        },
        cancelShadow() {
            this.isClick = false;
            // this.getShortOauthUrl(this.normalUrl, this.merchantCode);
            this.$nextTick(() => {
                this.shadowShow = false;
            });
        }
    },
    watch: {
        showBase: {
            handler: function (val, oldVal) {
                console.log('val: ' + val);
                console.log('oldVal: ' + oldVal);
                this.selectedString();
                if (val === false) {
                    this.isgocart = 0;
                }
            }
        },
        showCoupon(val, oldVal) {
            // console.log(val, oldVal);
        },
        videoShow(curVal, oldVal) {
            const ths = this;

            if (curVal) {
                if (this.createOnce) {
                    this.$nextTick(() => {
                        ths.popPlayer = document.querySelector('#swiperBigVideo');
                        // ths.popPlayer.play();
                        ths.createOnce = false;
                    });
                } else {
                    // ths.popPlayer.play();
                }
                ths.detailPlayer.pause();
            } else {
                if (ths.popPlayer) {
                    ths.popPlayer.pause();
                }
            }
        }
    },
    esvBack(backFn) {
        window.removeEventListener('popstate', this.goBack, false);
        this.ESVStorage.getSessionValue('baseSession', (data) => {
            const { merchantCode, link, wechatTitle } = { ...data };
            if (merchantCode && link && wechatTitle) {
                wxCircle(wechatTitle, link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg', 'home remove');
                wxFriends(wechatTitle, '', link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg');
            }
        });
        return backFn && backFn(true);
    }
};
</script>

<style lang="scss" scoped>
#main-container {
    padding-top: 0;

    // height: 100%;
}
.no-product {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    img {
        width: 80%;
        display: block;
        margin-bottom: 20px;
    }
    color: #999;
    text-align: center;
}

.bcBlack {
    background-color: #000;
}

.video-show-pop {
    width: 100%;
    background-color: #000;

}

.video-show-page {
    /deep/.van-overlay {
        background-color: #000;
    }
}

.mr10 {
    margin-right: 10px;
}

.priceBox {
    overflow: hidden;
}

.gooddetail {
    background-color: #f2f2f2;
    font-size: 14px;
    overflow-y: scroll;
}

/deep/.van-sku-header__goods-info {
    padding: 10px 10px 0 10px;
}

.cartPicFixed {
    position: fixed;
    top: 15px;
    right: 15px;
    z-index: 99;

    img {
        width: 32px;
    }
}

// 商品轮播
.playBtn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid #fff;
    background: rgba(0, 0, 0, 0.20);
}

.evaluation {
    margin-top: 12px;
    padding: 12px;
    background-color: #fff;

    &.evaluation2 {
        margin-bottom: 50px;
    }

    .evatitle {
        font-size: 16px;

        .evatitle-right {
            display: inline-block;
            float: right;
            padding-right: 20px;
            color: #EE2E50;
            font-size: 14px;
            background: url('../assets/img/goods/right.png') right center no-repeat;
            background-size: 8px 12px;
        }
    }
}

/* 商品图 */
.lunbo {
    position: relative;
    height: 355px;
    background: #fff;

    .custom-indicator {
        // position: relative;
        height: 22px;
        position: absolute;
        width: 100%;
        bottom: 50px;
        display: flex;
        justify-content: center;

        >div {
            width: 46px;
            height: 22px;
            font-size: 10px;
            border-radius: 11px;
            line-height: 23px;
            text-align: center;
            background: rgba(255, 255, 255, 0.60);
        }

        .indicator {
            position: absolute;
            right: 5px;

            // padding: 2px 5px;
            font-size: 12px;
            color: #fff;
            background: rgba(0, 0, 0, 0.1);
        }

        .swiper-active {
            background-image: linear-gradient(90deg, #F85B88 0%, #EE2E50 100%);
            color: #fff;
        }

    }

    .good-center {
        display: flex;
        align-items: center;
        justify-content: center;

        .good-img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
        }
    }
}

.goods-detail {
    background-color: #fff;
    padding: 12px;
    margin-bottom: 12px;

    .goodsprice {
        font-size: 20px;
        color: $primary-color;
        overflow: hidden;

        .price-title {
            display: flex;
            align-items: center;
            float: left;

            .openType {
                background: rgba(238, 46, 80, 0.20);
                border-radius: 10px;
                font-size: 9px;
                color: #EE2E50;
                padding: 0 5px;
                margin-left: 11px;
                line-height: 18px;
            }
        }

        .marketprice {
            height: 20px;
            line-height: 20px;
            margin-bottom: 8px;

            span {
                font-size: 14px;
                color: #999;

                &.price {
                    text-decoration: line-through;
                }
            }
        }
    }

    .goodstitle {
        color: #414141;
        font-size: 14px;
        // margin-bottom: 8px;
    }

    .goodstitle2 {
        color: $primary-color;
        font-size: 12px;
        // margin-bottom: 8px;
    }

    .buydata {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;

        span {
            font-size: 12px;
            color: #999;

            &.payNum {
                margin-right: 28px;
            }
        }
    }
}

/* 商品服务 */
.goodsservice {
    height: 50px;
    line-height: 50px;
    margin: 13px 0 12px;
    padding: 0 12px;
    background-color: #fff;

    p {
        background: url('../assets/img/goods/right.png') right center no-repeat;
        background-size: 8px 12px;
    }

    .servtitle {
        text-align: center;
        color: #414141;
        font-size: 16px;
        margin-top: 22px;
        margin-bottom: 25px;
        line-height: 20px;
    }

    .clickoff {
        width: 327px;
        height: 44px;
        line-height: 44px;
        margin: 0 auto;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 22px;
        margin-top: 229px;
        margin-bottom: 20px;
        background-color: $primary-color;
    }
}
.right-arrows {
    background: url('../assets/img/goods/right.png') right 4px no-repeat;
    background-size: 8px 12px;
}

/* 优惠活动优惠券 */
.couponshell {
    padding: 17px 12px 0;
    background-color: #fff;
    margin-bottom: 11px;

    .couponcontain {
        // border-bottom: 1px solid #E3E2E2;
        padding-bottom: 7px;
        &-right {
            width: 100%;
            .couponp {
                padding-right: 10px;
            }
            .s-r {
                color: $text-hint-color;
            }
            >div {
                display: flex;
                align-items: center;
                width: 100%;

                .integral-item {
                    padding-left: 5px;
                }

            }
            >div {
                margin-bottom: 10px;
            }
        }
        &-right-arrows {
            flex: none;
            font-size: 14px;
            padding-right: 12px;
            color: $text-hint-color;
        }
        &-left {
            flex: none;
            margin-right: 15px;
        }

        .couponp {

            // margin-bottom: 10px;
        }

        .activep {
            margin-bottom: 10px;
        }

        .mark {
            font-size: 9px;
            letter-spacing: 0.5px;
            border-radius: 10px;
            padding: 2px 5px 1px;
        }

        .coupon-title,
        .integral {
            background: rgba(238, 46, 80, 0.20);
            color: #EE2E50;
        }

        .coupon-title {
            margin-left: 15px;
        }

        .integral {
            margin-left: 47px
        }

        .mark2 {
            margin-left: 47px;
            background-color: rgba(255, 190, 43, 0.20);
            color: #FFBE2B;
        }

        .actFirst {
            width: 50px;
            white-space: nowrap;
            overflow: hidden;
            border: 1px solid #FFBE2B;
            padding: 0 3px;
            margin-right: 5px;
            color: #FFBE2B;
            font-size: 11px;
        }

        .mark3 {
            margin-left: 15px;
        }

        .mark4 {
            margin-left: 15px;
        }

        .f-right {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #bebec5;
            float: right;
            margin-right: 12px;
        }

        .firstcoupon {
            font-size: 11px;
            color: #ee2e50;
            letter-spacing: 0.4px;
            border: 1px solid #ee2e50;
            padding: 0 3px;
            border-radius: 2px;
            margin-right: 5px;
        }

        .paratitle {
            text-align: center;
            color: #414141;
            font-size: 16px;
            line-height: 20px;
            margin-top: 22px;
            margin-bottom: 15px;
        }

        .promotion-wrapper {
            height: 260px;
            overflow-y: scroll;
            margin: 0 19px;

            .couponcontentshell {
                padding: 0px 10px 8px;
                .title {
                    font-size: 14px;
                    color: #999;
                    margin: 20px 0 10px 0;
                }
                .coupon {
                    width: 100%;
                    margin-bottom: 8px;
                    font-size: 14px;
                    background: url('../assets/img/goods/CombinedShape.png') center center no-repeat;
                    background-size: 100% 88px;
                    .couponcontent {
                        width: 67%;
                        float: left;
                        height: 88px;
                        color: #ff873b;
                        font-size: 12px;
                        font-family: PingFangSC-Medium;
                        padding-left: 14px;
                        letter-spacing: 0;

                        .num {
                            font-size: 14px;

                            span {
                                font-size: 32px;
                            }
                        }

                        .limit {
                            letter-spacing: 0;
                        }

                        .period {
                            letter-spacing: 0;
                        }
                    }

                    .couponbtn {
                        width: 33%;
                        float: left;
                        height: 88px;
                        line-height: 88px;
                        text-align: center;
                        font-size: 14px;
                        color: #ff873b;
                    }
                }
                .coupon-diabled {
                    background: #f8f8f9;
                    .couponcontent {
                        color: #ccc !important;
                    }
                    .couponbtn {
                        color: #ccc !important;
                    }

                }
            }
        }
    }

    .clickoff {
        width: 327px;
        height: 44px;
        line-height: 44px;
        margin: 0 auto;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 22px;
        margin-top: 30px;
        margin-bottom: 20px;
        background-color: $primary-color;
    }
}

/* 商品规格 */
.specifications {
    height: 50px;
    line-height: 50px;
    padding: 0 12px;
    background-color: #fff;

    /deep/ .van-sku__stepper,
    .van-stepper {
        line-height: 30px;
    }

    p {
        background: url('../assets/img/goods/right.png') right center no-repeat;
        background-size: 8px 12px;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
        // word-break: break-all;
        padding-right: 10px;
        height: 50px;

        .notchoosed {
            float: right;
            margin-right: 13px;
            color: #bebec5;
        }

        .choosed {
            color: #414141;
            display: inline-block;
            width: calc(100% - 30px);
            padding-left: 5px;
            text-align: right;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            // width: 100%;
            // padding-right: 46px;
        }
    }
}

/deep/ .van-sku-body {
    max-height: 300px !important;

    /deep/ .van-sku-row {
        border-bottom: 1px solid #e3e2e2;
    }
}

.sku-wrapper {
    height: auto;

    /deep/ .van-sku-row__item {
        padding: 0 15px;
        margin: 0 10px 10px 0;
        height: 28px;
        min-width: 52px;
        line-height: 27px;
        font-size: 12px;
        color: #333;
        text-align: center;
        border: none;
        border-radius: 14px;
        background-color: #f2f2f2;
        border: 1px solid #f2f2f2;
    }

    /deep/ .van-sku-row__item--active {
        color: #EE2E50;
        background: #FFF6F8;
        border: 1px solid #EE2E50;
    }

    /deep/ .van-sku__quota {
        position: absolute;
        left: 164px;
        top: 40px;
        // position: relative;
        // margin-top: -10px;
    }

    /deep/ .van-sku-row__item--disabled {
        background: #F2F2F2;
        color: #BEBEC5;
    }
}

/* 商品参数 */
.parameter {
    height: 50px;
    line-height: 50px;
    padding: 0 12px;
    background-color: #fff;

    p {
        border-top: 1px solid #E3E2E2;
        background: url('../assets/img/goods/right.png') right center no-repeat;
        background-size: 8px 12px;

        .notchoosed {
            float: right;
            margin-right: 13px;
            color: #bebec5;
        }
    }

    .paratitle {
        text-align: center;
        color: #414141;
        font-size: 16px;
        line-height: 20px;
        margin: 22px 0 15px;
    }

    .attrsshell {
        height: 260px;
        overflow-y: scroll;
        padding: 0 12px;

        .attrs {
            line-height: 20px;
            padding: 12px 0;
            font-size: 14px;
            border-bottom: 1px solid #E3E2E2;

            .attr {
                color: #bebec5;
                vertical-align: top;
                width: 32%;
                float: left;
            }

            .content {
                width: 60%;
                float: left;
                display: inline-block;
                color: #414141;
            }
        }
    }

    .clickoff {
        width: 87.2%;
        height: 44px;
        line-height: 44px;
        margin: 0 auto;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 22px;
        margin-top: 30px;
        margin-bottom: 20px;
        background-color: $primary-color;
    }
}

/deep/ .copy {
    width: 100%;
    font-size: 12px;
    line-height: 18px;
    margin-top: 25px;
    visibility: hidden;
    overflow: initial;
    white-space: initial;
    text-overflow: inherit;
}

/* 商品详情图片 */
.detailimg {
    margin-bottom: 60px;
    text-align: center;

    .detailimgtitle {
        height: 38px;
        line-height: 38px;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        width: 100%;

        // text-align: center;
    }

    .detailimgContent {
        font-size: 0;
        width: 100%;

        img {
            width: 100%;
        }
    }
}

/* 底部tab栏 */
.downtab {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    font-size: 0;
    z-index: 999;
    background-color: #fff;
    padding-left: 18px;

    .btn {
        color: #414141;
        font-size: 10px;
        display: inline-block;
        text-align: center;

        img {
            width: 20px;
            height: 20px;
            font-size: 0;
            margin-left: -1px;
        }
    }

    .homebtn {
        margin: 8px 0px 8px 0;
        float: left;
        width: 13%;

        p {
            line-height: 9px;
        }
    }

    .collectbtn {
        cursor: pointer;
        margin: 8px 0px 8px 0px;
        float: left;
        width: 13%;

        a {
            color: #414141;
        }

        p {
            line-height: 9px;
        }
    }

    .eventbtn {
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 0 10px;
        float: right;
        color: #fff;
        width: 28%;
        font-size: 14px;
        // width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }

    .gobuybtn {
        border-radius: 0px 20px 20px 0px;
        background-color: $primary-color;
        margin-right: 7px;
    }

    .gocartbtn {
        border-radius: 20px 0px 0px 20px;
        background-color: #ffbe2b !important;
        border: none;
    }
}

/* 商品规格 */
.van-sku-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;

    .determine-btn {
        width: 87.2%;
        height: 44px;
        line-height: 44px;
        border-radius: 44px;
    }

    .left-btn {
        width: 39.5%;
        height: 40px;
        line-height: 40px;
        border-radius: 40px 0px 0px 40px;
        background-color: #ffbe2b !important;
        border: none;
    }

    .right-btn {
        width: 39.5%;
        height: 40px;
        line-height: 40px;
        border-radius: 0px 40px 40px 0px;
        background-color: #EE2E50;
        border: none;
    }
}

.van-sku-header {
    margin: 0;
    padding: 12px;
}

.van-sku-header__img-wrap {
    margin-top: 12px;
}

.van-popup {
    border-radius: 10px 10px 0 0;
    z-index: 2147483647 !important;
}

.van-popup.shadow {
    width: 100%;
    background-color: transparent;
}

.van-sku__close-icon {
    cursor: pointer;
}

.van-sku-container {

    // max-height: 60%;
    // width: 100%;
    // overflow: scroll;
    // -webkit-overflow-scrolling: touch;
    // position: absolute;
    // left: 50%;
    // bottom: 0;
    // padding:16px 0;
    // padding-bottom: 2px;
    /deep/.specifications /deep/.van-ellipsis {
        color: #333;
        top: 76px;
    }

    /deep/ .van-sku-header__goods-info {
        padding: 20px 0px 0px 10px;
    }

    /deep/ .specifications .van-ellipsis {
        top: 76px;
    }
}

.sale-promotion-wrapper {
    .title {
        font-size: 14px;
        color: #999;
        margin: 10px 0;
    }
    .activicontent {
        .activiall {
            p {
                font-size: 12px;
                color: #999;
                letter-spacing: 0;
            }
        }
    }
    .sale-promotion {
        display: flex;
        // height: 21px;
        // align-items: center;
        padding-left: 12px;

        .mark {
            margin-left: 0;
            margin-top: -2px;
            font-size: 9px;
            color: #ee2e50;
            letter-spacing: 0.5px;
            background: rgba(238, 46, 80, 0.2);
            border-radius: 7px;
            margin-right: 5px;
            height: 13px;
            line-height: 10px;
        }

        .content {
            color: #414141;
            font-size: 14px;
            flex: 1;
        }

        .myPoint {
            color: #999;
            font-size: 12px;
        }
    }
    .sale-promotion:not(:last-child) {
        margin-bottom: 8px;
    }
}

.numFonts {
    font-size: 12px !important;
    margin-left: 5px;
}

.buttonBox {
    color: #fff;
    background-image: linear-gradient(90deg, #FC5236 0%, #EE2E50 100%);
    border-radius: 1px;
    width: 82px;
    float: right;
    font-size: 14px;
    text-align: center;
    height: 30px;
    line-height: 30px;
}

.cellStyle {
    line-height: 30px;
    margin-bottom: 12px;
}

// .van-sku__price-num {
//     font-size: 14px!important;
// }
.inteDetails {
    margin-left: 10px;
    margin-top: 6px !important;
}

#detailVideo {
    width: 100%;
    // height: 300px;
    background-color: #000;
}

// #swiperBigVideo {
//     width: 100%;
//     // height: 300px;
//     background-color: #000;
// }
#swiperBigVideo {
    width: 100%;
    height: 100%;
    // height: 300px;
    background-color: #000;
}
</style>
